/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiChartRankDrection;
(function (ApiChartRankDrection) {
    ApiChartRankDrection["ASC"] = "ASC";
    ApiChartRankDrection["DESC"] = "DESC";
})(ApiChartRankDrection || (ApiChartRankDrection = {}));
export function ApiChartRankDrectionFromJSON(json) {
    return ApiChartRankDrectionFromJSONTyped(json, false);
}
export function ApiChartRankDrectionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiChartRankDrectionToJSON(value) {
    return value;
}
